// Cookie consent banner. HTML must include #cookiePolicy + #cookie_agree.
// Banner appears (via .is-visible class) after 100px scroll; click "agree" sets localStorage and hides.
// CSS handles fade — see _cookiebox.scss.
export function initCookiebox() {
  const policy = document.getElementById('cookiePolicy');
  const agreeBtn = document.getElementById('cookie_agree');
  if (!policy) return;
  if (localStorage.getItem('cookieUse') !== null) {
    return; // already consented — never show
  }
  const onScroll = () => {
    policy.classList.toggle('is-visible', window.scrollY > 100);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  if (agreeBtn) {
    agreeBtn.addEventListener('click', () => {
      window.removeEventListener('scroll', onScroll);
      localStorage.setItem('cookieUse', 'agree');
      policy.classList.remove('is-visible');
    });
  }
}
